import { createStyles, Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import { AiViewportWrapper } from '../AiViewportWrapper';
import { useAIAssistantContext } from '../hooks';
import { AIAssistantMode } from '../types';
import type { AiMessageProps } from './AiMessage';
import { AiMessage } from './AiMessage';
import { UserMessage } from './UserMessage';

const useStyles = createStyles(
	(
		theme,
		{
			shouldIncreaseHeight,
			scrollContainerHeight,
			shouldAddExtraSpaceBottom,
		}: {
			shouldIncreaseHeight: boolean;
			scrollContainerHeight?: number;
			shouldAddExtraSpaceBottom: boolean;
		}
	) => ({
		container: {
			minHeight: shouldIncreaseHeight
				? `calc(${scrollContainerHeight ? `${scrollContainerHeight}px` : `-160px + 100dvh`})`
				: undefined,
			paddingBottom: shouldAddExtraSpaceBottom
				? theme.spacing['5xl']
				: undefined,
		},
	})
);

function MessageGroupInternal({
	message,
	parentPrompt,
	shouldIncreaseHeight,
	...props
}: AiMessageProps & {
	shouldIncreaseHeight: boolean;
}) {
	const scrollContainerHeight = document.querySelector(
		'.ai-chat-scroll-container'
	)?.clientHeight;
	const store = useAIAssistantContext();
	const isSidebar = store.mode === AIAssistantMode.SIDEBAR;
	const { classes } = useStyles({
		shouldIncreaseHeight,
		shouldAddExtraSpaceBottom: !isSidebar && props.isLastMessage,
		scrollContainerHeight,
	});

	return (
		<AiViewportWrapper>
			<Stack
				spacing={0}
				className={classes.container}
				data-active-prompt={shouldIncreaseHeight ? 'true' : undefined}
			>
				<UserMessage message={message} parentPrompt={parentPrompt} />
				<AiMessage message={message} parentPrompt={parentPrompt} {...props} />
			</Stack>
		</AiViewportWrapper>
	);
}

export const MessageGroup = observer(MessageGroupInternal);
